export const VIDEO_EXTENSIONS = ["mp4", "ogv", "ogg"];
export var ImageExtension = /* @__PURE__ */ ((ImageExtension2) => {
  ImageExtension2["GIF"] = "gif";
  ImageExtension2["JPG"] = "jpg";
  ImageExtension2["JPEG"] = "jpeg";
  ImageExtension2["PNG"] = "png";
  ImageExtension2["EXR"] = "exr";
  ImageExtension2["KTX2"] = "ktx2";
  ImageExtension2["HDR"] = "hdr";
  return ImageExtension2;
})(ImageExtension || {});
export const IMAGE_EXTENSIONS = [
  "gif" /* GIF */,
  "jpeg" /* JPEG */,
  "jpg" /* JPG */,
  "png" /* PNG */,
  "exr" /* EXR */,
  "ktx2" /* KTX2 */,
  "hdr" /* HDR */
];
function urlExt(url) {
  const url_without_query_params = url.split("?")[0];
  const url_elements = url_without_query_params.split(".");
  const ext = url_elements[url_elements.length - 1];
  return ext;
}
export function isUrlVideo(url) {
  return VIDEO_EXTENSIONS.includes(urlExt(url).toLowerCase());
}
export function isUrlStaticImage(url) {
  return IMAGE_EXTENSIONS.includes(urlExt(url).toLowerCase());
}
export function isUrlGif(url) {
  return urlExt(url).toLowerCase() == "gif";
}
